import { useTranslation } from 'react-i18next'

import { ProfileInfoWidget } from '../../../Widget'

import { FINANCIAL_DETAILS_FIELDS } from './UserProfileWidgetFinancialDetails.constants'

function UserProfileWidgetFinancialDetails({
  canEdit,
  data,
  fieldVariables,
  isSkeleton,
  options,
  onSubmit,
}) {
  const { t } = useTranslation()

  return (
    <ProfileInfoWidget
      canEdit={canEdit}
      config={FINANCIAL_DETAILS_FIELDS}
      data={data}
      fieldVariables={fieldVariables}
      isSkeleton={isSkeleton}
      options={options}
      title={t('Widget.FinancialDetailsTitleKey')}
      onSubmit={onSubmit}
    />
  )
}

export default UserProfileWidgetFinancialDetails
